import React from "react";
import styled from "styled-components";
import {FaMusic} from "react-icons/fa";

const UploadBox = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
`;

const FileInputLabel = styled.label`
    background-color: green;
    color: white;
    padding: 0.75rem 1.5rem;
    border-radius: 0.5rem;
    font-weight: 600;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.3s ease;
    &:hover {
        background-color: darkgreen;
    }
`;

const HiddenFileInput = styled.input`
    display: none;
`;

const FileName = styled.p`
    font-size: 0.95rem;
    color: #aaa;
    padding: 0 0 8px;
`;

const DemoSubmission = ({fileName, handleFileChange}) => {
    return (
        <UploadBox>
            <FileInputLabel htmlFor="demo-audio-upload">
                <FaMusic />
                <div style={{display: "flex", flexDirection: "column"}}>
                    <p> Upload Demo Now</p>
                    <span style={{fontSize: "10px"}}>Maximum allowed is 5MB</span>
                </div>
            </FileInputLabel>
            <HiddenFileInput
                type="file"
                id="demo-audio-upload"
                accept="audio/*"
                onChange={(e) => handleFileChange(e, "demo")}
            />
            {fileName && <FileName>Selected: {fileName}</FileName>}
        </UploadBox>
    );
};

export default DemoSubmission;
